'use client';

import Image from 'next/image';
import Link from 'next/link';
import { Suspense } from 'react';
import ProductFavoriteMarker from '@/app/_components/ProductFavoriteMarker';
import { decodeEntities } from '@/app/_lib/services/ClientUtil';
import Price from '@/app/_components/Price';
import { useHmSpecialSale, isHmSpecialSaleProduct } from '@/app/_lib/hooks/useHmSpecialSale';

// className="border min-w-[150px] min-h-[150px] transition-all duration-500 scale-100 group-hover:scale-110 mx-auto"

const ProductListing = ({
  product,
  hideDetails,
  additionalClasses,
  closeSearch
}) => {
  // HM special (code) sale line under the price - same rule as the category
  // cards (switch on, MillerKnoll supplier, on sale); one live fetch per page
  // shared by every result. Needs supplier_id in the search hit.
  const specialSale = useHmSpecialSale(true);
  const imageSrc = product.image;
  if (!product.url) {
    product.url = '/';
  }
  return <Link href={product.url} className={`relative group flex items-start gap-3 ${additionalClasses ? className : ''}`}>
            <div className="shrink-0 overlay-block p-2">
                <Image className="w-[100px] h-[100px] object-contain scale-100 lg:transition-all lg:duration-500 lg:group-hover:scale-110" src={imageSrc} alt={decodeEntities(product.sub_product_name)} placeholder="blur" blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcIgkAAYcAz3yXgHoAAAAASUVORK5CYII=" width={100} height={100} quality={90} sizes="100px" />
            </div>
            <div className={`flex-1 text-left`}>
                {product.on_sale && product.discount_percentage > 0 && <div className="text-3xs mb-1 text-red">
                        <span className="font-semibold">Sale</span> {product.discount_percentage}% off
                    </div>}
                <div className="capitalize font-medium text-xs mb-1">{decodeEntities(product.sub_product_name)}</div>
                <div className="capitalize font-light text-2xs text-neutral-600 mb-1">
                    {product.price_low > 0 && product.price_high > 0 && product.price_high > product.price_low ? <>
                            <div className={product.original_price_low ? 'text-dark' : ''}>
                                <Price amount={product.price_low} /> - <Price amount={product.price_high} />
                            </div>
                            {product.original_price_low > 0 && <div className="line-through text-light">
                                    <Price amount={product.original_price_low} /> - <Price amount={product.original_price_high} />
                                </div>}
                        </> : product.lowest_price > 0 && product.highest_price > 0 && product.highest_price > product.lowest_price ? <div><Price amount={product.lowest_price} /> - <Price amount={product.highest_price} /></div> : <div>
                            <span className={product.original_price ? 'text-dark' : ''}>
                                <Price amount={product.price || product.retail_price} />
                            </span>
                            {product.original_price > 0 && <Price amount={product.original_price} className="line-through text-light ml-1" />}
                        </div>}
                </div>
                {isHmSpecialSaleProduct(product, specialSale) && <div className="text-3xs text-red mb-1">Save 20% With Code HM20</div>}
                {product.shipping?.product_listing_message?.length > 0 && <div className="text-3xs text-light mb-1">
                        {product.shipping.product_listing_message}
                    </div>}
                <div className="flex items-center justify-start space-x-2">
                    <div className={`capitalize text-3xs font-medium ${product.designer_name ? 'border-r-1 pr-2' : ''}`}>{product.supplier_name}</div>
                    <div className="capitalize text-3xs text-light">{product.designer_name}</div>
                </div>
            </div>

        </Link>;
};
export default ProductListing;